import * as React from 'react';
import { compose, setDisplayName } from 'recompose';
import { connect } from 'react-redux';
import { persist } from 'ui/shared/persist';
import { skin, OemProps } from 'ui/styles/skin';
import { State } from 'reducers';
import { setLanguageRequest } from 'actions/shellActions';
import { getLanguage } from 'selectors/shellSelectors';
import { getAvailableLanguages } from 'selectors/serverSelectors';
import { Select } from 'ui/shared/Select';
import { bundledLanguages } from 'sagas/shell/setLanguageSaga';
import { Language } from 'types';

const LanguagePickerComponent = ({ active, available, onChange, styles }: StateProps & DispProps & OemProps) =>
    <Select
        id="language-picker"
        onChange={ e => onChange(e.target.value) }
        value={ active }
        style={ styles.Input }
    >
        { available
            .filter(l => bundledLanguages.indexOf(l.code) >= 0)
            .map(l => <option key={ l.code } value={ l.code }>{ l.name }</option>)
        }
    </Select>
;

export type OwnProps = {
    saved: string;
};
export type StateProps = {
    active: string;
    available: ReadonlyArray<Language>;
};
export type DispProps = {
    onChange: (lang: string) => void;
};

const mapStateToProps = (state: State, props: OwnProps): StateProps => ({
    active: getLanguage(state) || props.saved || 'en',
    available: getAvailableLanguages(state) || [{ code: 'en', name: 'English' }],
});
const mapDispatchToProps = (dispatch: Function): DispProps => ({
    onChange: lang => dispatch(setLanguageRequest(lang)),
});

export const LanguagePicker = compose<StateProps & DispProps & OemProps, {}>(
    setDisplayName('LanguagePicker'),
    skin,
    persist({ // Note: this persist is read only... the onChange isn't hooked up. Instead, the setLanguageSaga writes the value for us
        storage: window.localStorage,
        key: 'lang',
        valueName: 'saved',
    }),
    connect(mapStateToProps, mapDispatchToProps),
)(LanguagePickerComponent);



// WEBPACK FOOTER //
// ./src/ui/main/header/LanguagePicker.tsx